import React, { useCallback, useState } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useIntl } from "react-intl";
import { messages } from "./Composition.messages";
import { useBlocks, useUi } from "@jelly/lesson";

import styles from "./Composition.module.scss";
import { BioModal } from "@src/lms/jelly/extensions/layouts/_lesson/case4/components/BioModal";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import config from "appConfig";

export const Composition: React.FC = () => {
  const ui = useUi();

  const blocks = useBlocks();
  const { formatMessage } = useIntl();

  const [BioModalOpen, setBioModalOpen] = useState(false);

  const handleBioModalToggle = useCallback(() => setBioModalOpen((open) => !open), []);

  const leftComponent = (
    <div className={styles.leftComponent}>
      <div style={{ width: "100%", height: "142px" }}>
        <blocks.video src={"https://youtu.be/reL5AGu6N6A"} provider={"youtube"} />
      </div>
      <p>{formatMessage(messages.C4_P2_S1_Video_Description)}</p>
      <ui.Button shape={"normal"} theme={"primary"} size={"small"} onClick={handleBioModalToggle}>
        {formatMessage(messages.C4_P2_S1_Bio_Button_Label)}
      </ui.Button>
    </div>
  );

  return (
    <div className={styles.root}>
      <StandardCase title={formatMessage(messages.C4_P2_S1_Title)} leftComponent={leftComponent}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <blocks.image src={`${config.STATIC_ASSETS_URL}/lms/case/case04/composition1.png`} />
                <p className={styles.caption}>{formatMessage(messages.C4_P2_S1_Image_Caption1)}</p>
              </div>,

              <div key={2} className={styles.carouselItem}>
                <blocks.image src={`${config.STATIC_ASSETS_URL}/lms/case/case04/composition3.png`} />
                <p className={styles.caption}>{formatMessage(messages.C4_P2_S1_Image_Caption3)}</p>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </StandardCase>
      <BioModal
        visible={BioModalOpen}
        onClose={handleBioModalToggle}
        title={formatMessage(messages.C4_P2_S1_Bio_Title)}
        description={formatMessage(messages.C4_P2_S1_Bio_Text)}
      />
    </div>
  );
};
